var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewsStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 12.956,
    viewBox: "0 0 74 12.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3730",
    "data-name": "Group 3730",
    transform: "translate(-65.493 -228.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M72.3,228.012l2.1,4.265,4.707.684-3.406,3.32.8,4.688-4.21-2.213-4.21,2.213.8-4.688-3.406-3.32,4.707-.684Z",
    fill: "#fbbd04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M127.7,228.012l2.1,4.265,4.707.684-3.406,3.32.8,4.688-4.21-2.213-4.21,2.213.8-4.688-3.406-3.32,4.707-.684Z",
    transform: "translate(-40.3)",
    fill: "#fbbd04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M183.091,228.012l2.1,4.265,4.707.684-3.406,3.32.8,4.688-4.21-2.213-4.21,2.213.8-4.688-3.406-3.32,4.707-.684Z",
    transform: "translate(-80.599)",
    fill: "#fbbd04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M238.485,228.012l2.1,4.265,4.707.684-3.406,3.32.8,4.688-4.21-2.213-4.21,2.213.8-4.688-3.406-3.32,4.707-.684Z",
    transform: "translate(-120.899)",
    fill: "#fbbd04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M293.879,228.012l2.1,4.265,4.707.684-3.406,3.32.8,4.688-4.21-2.213-4.21,2.213.8-4.688-3.406-3.32,4.707-.684Z",
    transform: "translate(-161.198)",
    fill: "#fbbd04"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsStars);
export default __webpack_public_path__ + "static/media/reviewsStars.aa69a2a26d0dca629b64981332bef29e.svg";
export { ForwardRef as ReactComponent };